import { useState, useEffect } from "react"
import './SliderVertical.css'

interface SlideData {
  id: number
  title: string
  subtitle: string
  image: string
  logoPosition: string // Agregando posición para el logo
}

const slides: SlideData[] = [
  {
    id: 1,
    title: "Encontrar tu nuevo hogar",
    subtitle: "Descubre los mejores inmuebles para vivir o invertir. ¡Te apoyamos a construir tu patrimonio!",
    image: "https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/login1.jpg",
    logoPosition: "top-8 right-8", // Logo en esquina superior derecha
  },
  {
    id: 2,
    title: "Vender mi propiedad",
    subtitle: "¡Haz el proceso 100% digital! Selecciona tus propiedades favoritas, programa tus visitas, oferta y negocia con el propietario y firma el contrato digitalmente.",
    image: "https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/login2.jpg",
    logoPosition: "top-8 left-8", // Logo en esquina superior izquierda
  },
  {
    id: 3,
    title: "Alquilar mi propiedad y rental management",
    subtitle: "¡Despreocúpate de tu casa o apartamento! Nos encargamos de rentabilizar tus inversiones alquilando al mejor inquilino o vendiendo al mejor precio.",
    image: "https://images.pexels.com/photos/4246234/pexels-photo-4246234.jpeg",
    logoPosition: "top-1/2 right-8 -translate-y-1/2", // Logo en centro derecha
  },
//   {
//     id: 4,
//     title: "Marketing Digital",
//     subtitle: "¡Despreocúpate de tu casa o apartamento! Nos encargamos de rentabilizar tus inversiones alquilando al mejor inquilino o vendiendo al mejor precio.",
//     logo: "/placeholder.svg?height=80&width=80",
//     logoPosition: "top-1/3 left-8", // Logo en tercio superior izquierda
//   },
]

export default function VerticalSlider() {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true)

      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length)
        setIsAnimating(false)
      }, 300) // Duración de la animación de salida
    }, 4000) // Cambio cada 4 segundos

    return () => clearInterval(interval)
  }, [])

  const currentSlideData = slides[currentSlide]

  return (
    <div className="p-2 flex items-center justify-center lg:min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800">
      <div className="relative w-full max-w-md mx-auto stories-container">
        <h2 className="text-2xl font-semibold text-white">¡Hola, bienvenido!👋🏼</h2>
               <h4 className="font-normal text-xl mt-1 text-white mb-4">Con Propi puedes:</h4>
        <div className="relative w-full aspect-[9/16] rounded-3xl overflow-hidden shadow-2xl">
          <div
            className={`absolute inset-0 bg-cover bg-center transition-all duration-1000 ease-out ${
              isAnimating ? "scale-110 opacity-0" : "scale-100 opacity-100"
            }`}
            style={{
              backgroundImage: `url(${currentSlideData.image})`,
              animation: isAnimating ? "none" : "kenBurns 4s ease-out infinite alternate",
            }}
          />

          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-black/30" />

          <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/60 via-black/20 to-transparent">
            {/* Título */}
            <div
              className={`mb-2 transition-all duration-500 ease-out ${
                isAnimating ? "transform translate-y-8 opacity-0" : "transform translate-y-0 opacity-100"
              }`}
            >
              <h1 className="text-2xl font-semibold text-white leading-tight drop-shadow-lg">
                {currentSlideData.title}
              </h1>
            </div>

            {/* Subtítulo */}
            <div
              className={`transition-all duration-500 ease-out delay-100 ${
                isAnimating ? "transform translate-y-8 opacity-0" : "transform translate-y-0 opacity-100"
              }`}
            >
              <p className="text-sm font-light text-white/90 leading-relaxed drop-shadow-md">
                {currentSlideData.subtitle}
              </p>
            </div>
          </div>

          <div className="absolute top-4 left-4 right-4 flex space-x-1">
            {slides.map((_, index) => (
              <div key={index} className="flex-1 h-1 bg-white/30 rounded-full overflow-hidden">
                <div
                  className={`h-full bg-white rounded-full transition-all duration-300 ${
                    index < currentSlide ? "w-full" : index === currentSlide ? "w-full animate-pulse" : "w-0"
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
{/* 
        <div className="flex justify-center space-x-2 mt-6">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => {
                setIsAnimating(true)
                setTimeout(() => {
                  setCurrentSlide(index)
                  setIsAnimating(false)
                }, 300)
              }}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                index === currentSlide ? "bg-purple-500 scale-125" : "bg-gray-400 hover:bg-gray-600"
              }`}
              aria-label={`Ir al slide ${index + 1}`}
            />
          ))}
        </div> */}
      </div>
    </div>
  )
}
